import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Amplify from 'aws-amplify';

import * as workbox from './workbox';
import MainAppNavigator from './containers';
import createStore from './store';
import appConfig from './appConfig';
import './scss/styles.scss';
import 'react-tabs/style/react-tabs.css';

const { store, history } = createStore();

Amplify.configure(appConfig.AWS_CONFIG);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Router>
        <Route component={MainAppNavigator} />
      </Router>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);

workbox.register();
